import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { useNavigate } from 'react-router-dom';
import { signOut, updatePassword } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import NewsEditor from './NewsEditor';
import MenuManager from './MenuManager';
import NewsList from './NewsList';
import TodayPaperManager from './TodayPaperManager'; 
import EPaperManager from './EPaperManager'; 
import MagazineManager from './MagazineManager'; 
import SocialManager from './SocialManager';
import { doc, getDoc } from "firebase/firestore";
import TopViewedNews from "./TopViewedNews";

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('news');
  const [hoveredTab, setHoveredTab] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const navigate = useNavigate();
const [totalVisitors, setTotalVisitors] = useState(0);
const [todayVisitors, setTodayVisitors] = useState(0);
const [totalNewsViews, setTotalNewsViews] = useState(0);
const [todayNewsViews, setTodayNewsViews] = useState(0);

 const handleLogout = async () => {
    try {
      // ১. প্রথমে ফায়ারবেস থেকে সাইন আউট করুন
      await signOut(auth);
      
      // ২. এবার localStorage থেকে তথ্যটি মুছে ফেলুন (অত্যন্ত জরুরি!)
      localStorage.removeItem("isAdminLoggedIn");
      
      // ৩. সবশেষে লগইন পেজে পাঠিয়ে দিন
      navigate('/login');
    } catch (error) {
      alert("লগআউট করতে সমস্যা হচ্ছে!");
    }
};

useEffect(() => {
  const loadStats = async () => {
    // Visitors
    const snap = await getDoc(doc(db, "site_stats", "visitors"));

   if (snap.exists()) {
  const data = snap.data();

  const now = new Date();

  const today =
    now.getFullYear() +
    "-" +
    String(now.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(now.getDate()).padStart(2, "0");

  setTotalVisitors(data.total || 0);
  setTodayVisitors(data[today] || 0);
  setTotalNewsViews(data.totalNewsViews || 0);
  setTodayNewsViews(data[`${today}-news`] || 0);
}
  };

  loadStats();
}, []);

  const handleUpdatePassword = async () => {
    try {
      await updatePassword(auth.currentUser, newPassword);
      alert("পাসওয়ার্ড সফলভাবে পরিবর্তিত হয়েছে!");
    } catch (error) {
      alert("পাসওয়ার্ড আপডেট করা যায়নি: " + error.message);
    }
  };

  const btnStyle = (active, isHovered) => ({
    padding: '12px 25px',
    backgroundColor: active ? '#8b0000' : (isHovered ? '#8b0000' : '#888'),
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    fontWeight: 'bold',
    transition: 'all 0.3s ease',
    borderRadius: '4px',
    margin: '0 2px'
  });

const StatCard = ({ title, value }) => (
  <div
    style={{
      background: "#f8f8f8",
      border: "1px solid #ddd",
      borderRadius: 6,
      padding: "10px 12px",
      textAlign: "center",
      minHeight: "85px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    }}
  >
    <h3
      style={{
        margin: 0,
        fontSize: "15px",
        fontWeight: "600",
        color: "#555"
      }}
    >
      {title}
    </h3>

    <h1
      style={{
        margin: "8px 0 0",
        color: "#8b0000",
        fontSize: "28px",
        lineHeight: 1.1
      }}
    >
      {(value || 0).toLocaleString()}
    </h1>
  </div>
);

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h2 style={{ color: '#8b0000', textAlign: 'center', marginBottom: '20px' }}>অ্যাডমিন ড্যাশবোর্ড</h2>
	<div
  style={{
    display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
gap: 12,
    marginBottom: 20
  }}
>
 <StatCard title="🔥 আজকের নিউজ ভিউ" value={todayNewsViews} />
  <StatCard title="📰 মোট নিউজ ভিউ" value={totalNewsViews} />
  <StatCard title="📅 আজকের ভিজিটর" value={todayVisitors} />
   <StatCard title="👥 মোট ভিজিটর" value={totalVisitors} />
 
</div>

      <div style={{ display: 'flex', gap: '5px', justifyContent: 'center', marginBottom: '25px', flexWrap: 'wrap' }}>
        <button style={btnStyle(activeTab === 'news', hoveredTab === 'news')} onClick={() => setActiveTab('news')} onMouseEnter={() => setHoveredTab('news')} onMouseLeave={() => setHoveredTab(null)}>নিউজ পাবলিশ</button>
        <button style={btnStyle(activeTab === 'list', hoveredTab === 'list')} onClick={() => setActiveTab('list')} onMouseEnter={() => setHoveredTab('list')} onMouseLeave={() => setHoveredTab(null)}>নিউজ লিস্ট</button>
        <button style={btnStyle(activeTab === 'menu', hoveredTab === 'menu')} onClick={() => setActiveTab('menu')} onMouseEnter={() => setHoveredTab('menu')} onMouseLeave={() => setHoveredTab(null)}>মেনু সেটিংস</button>
		<button style={btnStyle(activeTab === 'todayPaper', hoveredTab === 'todayPaper')} onClick={() => setActiveTab('todayPaper')} onMouseEnter={() => setHoveredTab('todayPaper')} onMouseLeave={() => setHoveredTab(null)}>আজকের পত্রিকা</button>
  <button style={btnStyle(activeTab === 'ePaper', hoveredTab === 'ePaper')} onClick={() => setActiveTab('ePaper')} onMouseEnter={() => setHoveredTab('ePaper')} onMouseLeave={() => setHoveredTab(null)}>ই-পেপার</button>
  <button style={btnStyle(activeTab === 'magazine', hoveredTab === 'magazine')} onClick={() => setActiveTab('magazine')} onMouseEnter={() => setHoveredTab('magazine')} onMouseLeave={() => setHoveredTab(null)}>ম্যাগাজিন</button>
  <button style={btnStyle(activeTab === 'social', hoveredTab === 'social')} onClick={() => setActiveTab('social')} onMouseEnter={() => setHoveredTab('social')} onMouseLeave={() => setHoveredTab(null)}>সোশ্যাল মিডিয়া</button>
        <button style={btnStyle(activeTab === 'settings', hoveredTab === 'settings')} onClick={() => setActiveTab('settings')} onMouseEnter={() => setHoveredTab('settings')} onMouseLeave={() => setHoveredTab(null)}>লগইন সেটিংস</button>
     <button
  style={btnStyle(activeTab === 'topNews', hoveredTab === 'topNews')}
  onClick={() => setActiveTab('topNews')}
  onMouseEnter={() => setHoveredTab('topNews')}
  onMouseLeave={() => setHoveredTab(null)}
>
  🏆 নিউজ ভিউ
</button>
	 </div>

      <div style={{ padding: '20px', backgroundColor: '#ffffff', borderRadius: '8px', border: '1px solid #e0e0e0', minHeight: '600px' }}>
        {activeTab === 'news' && <NewsEditor />}
        {activeTab === 'list' && <NewsList />}
        {activeTab === 'menu' && <MenuManager />}
		{activeTab === 'todayPaper' && <TodayPaperManager />}
        {activeTab === 'ePaper' && <EPaperManager />}
        {activeTab === 'magazine' && <MagazineManager />}
        {activeTab === 'social' && <SocialManager />}
		{activeTab === 'topNews' && <TopViewedNews />}
        {activeTab === 'settings' && (
          <div>
            <h3>লগইন সেটিংস</h3>
            <div style={{ marginBottom: '20px' }}>
              <input 
                type="password" 
                placeholder="নতুন পাসওয়ার্ড" 
                onChange={(e) => setNewPassword(e.target.value)} 
                style={{ padding: '8px', marginRight: '10px', borderRadius: '4px', border: '1px solid #ccc' }} 
              />
              <button 
                onClick={handleUpdatePassword} 
                onMouseEnter={(e) => e.target.style.backgroundColor = '#8b0000'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#555'}
                style={{ 
                  padding: '8px 15px', 
                  backgroundColor: '#8b0000', 
                  color: '#fff', 
                  border: 'none', 
                  cursor: 'pointer',
                  borderRadius: '4px',
                  transition: 'background-color 0.3s ease'
                }}
              >
                পাসওয়ার্ড পরিবর্তন
              </button>
            </div>
            <button 
              onClick={handleLogout} 
              onMouseEnter={(e) => e.target.style.backgroundColor = '#8b0000'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#555'}
              style={{ 
                padding: '10px 20px', 
                backgroundColor: '#555', 
                color: '#fff', 
                border: 'none', 
                cursor: 'pointer',
                borderRadius: '4px',
                transition: 'background-color 0.3s ease'
              }}
            >
              লগআউট করুন
            </button>
          </div>
        )}
		
      </div>
    </div>
  );
};

export default AdminDashboard;